import { CAMERA_SOCKET_PATH } from './cameraSocketPath';

/**
 * Shared Socket.IO options for camera. Polling first avoids many ingress/proxy setups that
 * mishandle WebSocket upgrade on paths like /api/socket.io (connection still upgrades to WS when possible).
 */
export function getCameraIoOptions(token, extra = {}) {
  return {
    path: CAMERA_SOCKET_PATH,
    auth: { token },
    query: { token },
    transports: ['polling', 'websocket'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 15000,
    timeout: 20000,
    autoConnect: true,
    ...extra,
  };
}
